import { gql } from 'graphql-request';

export default gql`query($filter: ColorTemperatureInput) {
  fluxRange(filter: $filter) {
    min_flux
    max_flux
    min_power
    max_power
    diode_ids
  }
}`;